import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="users--manage-grants"
export default class extends Controller {
  static targets = ["grant", "seller_id", "group_id"];

  connect() {
    this.displayInputs();
  }

  handleSelect(event) {
    console.log(event, this.grantTarget.value);
    this.displayInputs();
  }

  displayInputs() {
    if (this.grantTarget.value.includes("PLATFORM")) {
      this.seller_idTarget.classList.add("hidden");
      this.group_idTarget.classList.add("hidden");
    }

    if (this.grantTarget.value.includes("SELLER")) {
      this.seller_idTarget.classList.remove("hidden");
      this.group_idTarget.classList.add("hidden");
    }

    if (this.grantTarget.value.includes("GROUP")) {
      this.seller_idTarget.classList.add("hidden");
      this.group_idTarget.classList.remove("hidden");
    }
  }
}
